import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../services/master-data.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit {
  menuList;
  userRole;
  allowedComponents = new Set<string>();
  isPartner = false;
  isAccountVertical = false;
  isHrVertical = false;

  constructor(private masterDataService:MasterDataService) { }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });
    });
   
    var role = localStorage.getItem('userRole');
     console.log('report userROle',role);
    var serviceVertical = localStorage.getItem('serviceVertical');

    if (role === 'Managing Partner' || role === 'Designated Partner' || role === 'Partner') {
      this.isPartner = true;
    }

    if (serviceVertical === 'Accounts (LLP)') {
      this.isAccountVertical = true;
    }

    if (serviceVertical === 'Human Resource (LLP)') {
      this.isHrVertical = true;
    }
    console.log('isPartner', this.isPartner);
    console.log('isAccountVertical', this.isAccountVertical);
    console.log('isHrVertical', this.isHrVertical);
  }

  hasAccess(componentName: string): boolean {
    return this.allowedComponents.has(componentName);
  }

}
